<template>
  <v-text-field
    :label="propLabel || def && def.name"
    v-bind="$attrs"
    class="test"
    auto-grow
    filled
    :type="inputType==='itPassword' ? 'password': 'text' "
    v-on="$listeners"
  >
    <template #prepend-inner>
      <AppToolTip
        v-if="def && def.help"
        :def="def.help"
      ></AppToolTip>
    </template>
    <template #label>
      <div>
        {{ propLabel }}<span
          v-if="def && def.kind === 'TFormProp' && def.required || ($attrs && $attrs.required)"
          class="red--text font-weight-bold"
        > *</span>
      </div>
    </template>
    <template #append>
      <v-icon
        v-if="model && model.__proxy__ && model.__proxy__.isDirty(def.name)"
        @click="model && model.__proxy__ && model.__proxy__.undo(def.name)"
      >
        mdi-undo
      </v-icon> 
      <!-- <v-icon
        v-if="model && model.$isDirty && model.$isDirty(def.name)"
        @click="model.$undo(def.name)">mdi-undo</v-icon>   -->
      <div
        v-if="def && def.suffixLabel"
        style="color:grey; font-size:0.8rem; padding-top: 3px;"
      >
        {{ $t(def.suffixLabel) }}
      </div>  
    </template>
    <slot
      v-for="(_, slot) of $slots"
      :slot="slot"
      :name="slot"
    />
    <template
      v-for="(_, slot) of $scopedSlots"
      :slot="slot"
      slot-scope="scope"
    >
      <slot
        :name="slot"
        v-bind="scope"
      />
    </template>
  </v-text-field>
</template>

<script>
import AppToolTip from "@/components/library/common/AppToolTip";
export default {
  name: "AppTextField",
  components: {AppToolTip},
  props: ["def", "model"],
  data() {
    return{
      inputType: undefined
    }
  },
  computed: {
    propLabel() {
      let label = this.$t(this.def);
      return label;
    }
  },
  mounted() {
    this.inputType = this.def.inputType?.name.split(".").pop();
    
  }
};
</script>
<style>
.v-input__slot{
  padding-bottom: 0 !important;
  margin-bottom: 0;
  font-size: 14px!important;
}
.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
  padding: 0 12px;
  border: 1px solid rgba(224, 224, 224, 1);
  box-sizing: border-box;
  border-radius: 4px;
  background-color: transparent;
  /*height: 56px;*/
  margin-bottom: 2px;
  
}
.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot:hover {
  padding: 0 12px;
  border: 1px solid rgba(224, 224, 224, 1);
  box-sizing: border-box;
  border-radius: 4px;
  background-color: transparent;
  margin-bottom: 2px;
}
.v-text-field > .v-input__control > .v-input__slot:before, .v-text-field > .v-input__control > .v-input__slot:after {
  visibility: hidden;
}
 .v-text-field__slot label, .v-auto-complete__slot label, .v-select__slot .v-label, .v-list-item__title {
  font-size: 12px !important;
}
.v-text-field--filled .v-label--active, .v-text-field--full-width .v-label--active {
  transform: translateY(-5px) scale(0.73);
  top:10px!important;
}

</style>
